'use client'

import { Suspense, useEffect } from 'react'
import { useSearchParams } from 'next/navigation'

/**
 * Guarda la atribución de campaña propia (`utm_source=rockthesport`) en la cookie `utm_info`.
 *
 * Es un COMPONENTE HOJA, no un provider: sustituye al antiguo `QueryParamsProvider`, que envolvía
 * `{children}` del layout raíz en un `<Suspense>` para poder usar `useSearchParams()`. Ese
 * Suspense era el único límite de streaming por encima de la página y hacía que Next descargara
 * el shell —y con él la cabecera HTTP 200— antes de que la página resolviera: cualquier
 * `notFound()` posterior solo podía cambiar el CUERPO, nunca el código de estado, así que todas
 * las páginas inexistentes del sitio respondían 200 (soft 404). Aquí el Suspense envuelve solo a
 * este componente, que no renderiza nada.
 *
 * El contexto que exponía aquel provider estaba vacío (`{}`) y `useQueryParams()` no se usaba en
 * ningún sitio, así que no se pierde nada.
 */
function UtmCookieWriter() {
  const searchParams = useSearchParams()

  useEffect(() => {
    if (typeof window === 'undefined') return

    const source = searchParams.get('utm_source')
    const medium = searchParams.get('utm_medium')
    const campaign = searchParams.get('utm_campaign')

    // Solo se persiste la atribución PROPIA y solo con los tres campos presentes.
    if (!source || !medium || !campaign) return
    if (source.toLowerCase() !== 'rockthesport') return

    // La primera atribución manda: no se pisa una campaña anterior aún vigente.
    if (document.cookie.split('; ').some(row => row.startsWith('utm_info='))) return

    const expirationDate = new Date()
    expirationDate.setDate(expirationDate.getDate() + 14)

    const value = encodeURIComponent(JSON.stringify({
      utm_source: source,
      utm_medium: medium,
      utm_campaign: campaign,
    }))
    document.cookie = `utm_info=${value}; expires=${expirationDate.toUTCString()}; path=/`
  }, [searchParams])

  return null
}

export function UtmAttributionTracker() {
  return (
    <Suspense fallback={null}>
      <UtmCookieWriter />
    </Suspense>
  )
}
